// @flow

import React from 'react'
import styled, { css } from 'styled-components'
import { mediaMin } from 'frontend_core/dist/styles/media'
import Colors from 'components/styles/colors'
import Icon from 'components/atoms/Icon'

const CheckLabelComponent = styled.div`
  display: table;
  border-radius: 50%;
  cursor: pointer;
  color: ${Colors.grayD};
  border: 1px solid ${Colors.grayD};
  background-color: ${Colors.white};
  ${({ medium }) =>
    medium &&
    css`
      width: 32px;
      height: 32px;
      ${mediaMin.phone`
      width: 40px;
      height: 40px;
    `};
    `} ${({ checked }) =>
    checked &&
    css`
      color: ${Colors.blue};
      border: 1px solid ${Colors.blue};
    `};
`

const CheckLabelComponentContent = styled.div`
  display: table-cell;
  vertical-align: middle;
  text-align: center;
`

export type PropTypes = {
  checked: boolean,
  medium?: boolean,
}

export default (props: PropTypes) => (
  <CheckLabelComponent medium={props.medium} checked={props.checked}>
    <CheckLabelComponentContent>
      <Icon className="fa fa-check" fontSizeSp={16} fontSizePc={20} />
    </CheckLabelComponentContent>
  </CheckLabelComponent>
)



// WEBPACK FOOTER //
// ./src/components/atoms/CheckLabel/index.jsx